import types from './types'
import { Article } from '@/networks/api'

export default {
  state() {
    return {
      data: null,
      content: null,
      leftList: null
    }
  },
  mutations: {
    [types.SET_ARTICLE_INFO](state, payload) {
      state.data = payload
    },
    [types.SET_ARTICLE_CONTENT](state, payload) {
      state.content = payload
    },
    [types.SET_ARTICLE_LEFTLIST](state, payload) {
      state.leftList = payload
    }
  },
  actions: {
    async [types.GET_ARTICLE_INFO]({ commit, rootState }, { route }) {
      try {
        const {
          params: { id }
        } = route
        const { data } = await Article.getArticles(id, { rootState })
        commit(types.SET_ARTICLE_INFO, data && data.data)
        commit(types.SET_ARTICLE_CONTENT, data && data.data && data.data.content)
        commit(types.SET_ARTICLE_LEFTLIST, data && data.data && data.data.leftList)
      } catch (e) {
        commit(types.SET_ARTICLE_INFO, null)
        commit(types.SET_ARTICLE_CONTENT, null)
        commit(types.SET_ARTICLE_LEFTLIST, null)
        const response = e.response
        const status = response && response.status
        if (status === 404) return
        console.log('APIERROR==GET_ARTICLE_INFO==', e)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Article/store/index.js